export const normalizeWhiteSpace = (data: string) => data && data.trim().replace(/\s+/g, ' ');
